/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocumentFilter extends models.AwsSsmBaseDocumentFilter {
    constructor() {
        super();
        this.setDiscriminator("AwsSsmDocumentFilter");
    }

    getFixupPrototypeFunction() { return AwsSsmDocumentFilter.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocumentFilter>): AwsSsmDocumentFilter {
        let obj = Object.assign(new AwsSsmDocumentFilter(), model);
        AwsSsmDocumentFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocumentFilter>): AwsSsmDocumentFilter {
        if (!model) return null;
        return AwsSsmDocumentFilter.newInstance(<AwsSsmDocumentFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocumentFilter) {
        if (!obj) return;

        models.AwsSsmDocumentFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocumentFilter): boolean {
        if (models.AwsSsmBaseDocumentFilter.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSsmDocumentFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.filters) {
            models.AwsSsmDocumentQueryFilters.fixupPrototype(this.filters);
        }
    }

    /**
     * The AWS user that created the document.
     */
    owners: Array<string>;

    /**
     * The classification of a document to help you identify and categorize its use.
     */
    categories: Array<string>;

    /**
     * The list of operating system (OS) platforms compatible with available SSM documents.
     */
    platform_types: Array<string>;

    /**
     * Account filters for the tags
     */
    filters: models.AwsSsmDocumentQueryFilters;

}
